import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';

export class PlatformState {
    propertyUUID: string;
    hasStories: number;
    hasAudience: number;
    hasDiscoveryIntegration: boolean;
}


@Injectable({ providedIn: 'root' })
export class PlatformStateService {

    /**
     * A signal behind the accessor (FTK-7973). `state` is written by an APP_INITIALIZER in
     * app.module.ts that nothing awaits, so it can land after a tab's first render. As a plain
     * field that write notified nothing, and under zoneless change detection People and Stories
     * kept showing their upsell to properties that have the feature. A template or `computed` that
     * reads `state` now re-renders when it lands.
     */
    private readonly stateSignal = signal<PlatformState | undefined>(undefined);

    get state(): PlatformState | undefined {
        return this.stateSignal();
    }

    set state(value: PlatformState | undefined) {
        this.stateSignal.set(value);
    }

    constructor(
        private httpClient: HttpClient
    ) { }

    load(propertyUuid: string): Promise<PlatformState> {
        return this.httpClient.get<PlatformState>(`/api/v2/${propertyUuid}/properties/${propertyUuid}/platform-state`)
            .toPromise();
    }
}